import { createRouter, createWebHistory } from "vue-router";
import { getTenantConfig, getTenantSlug } from "@/config/tenants";

const tenant = getTenantConfig();
const tenantSlug = getTenantSlug();

function tenantHasFeature(feature) {
  return tenant?.features?.[feature] === true;
}

function getAdvisoryDutyComponent() {
  if (tenantSlug === "bv") return () => import("@/views/BvAdvisoryDuty.vue");
  return () => import("@/views/AdvisoryDuty.vue");
}

const routes = [
  {
    path: "/",
    redirect: () => {
      if (tenantHasFeature("advisoryDuty")) return "/advisory-duty";
      return "/404";
    },
  },
  {
    path: "/advisory-duty",
    name: "AdvisoryDuty",
    component: getAdvisoryDutyComponent(),
    beforeEnter: () => {
      if (!tenantHasFeature("advisoryDuty")) return { name: "NotFound" };
    },
  },
  {
    path: "/404",
    name: "NotFound",
    component: () => import("@/views/NotFound.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
